import { Badge, HStack } from '@chakra-ui/react'
import React from 'react'

import type { OrderType } from '@wanda-space/types'

import type { OrderAdminResponseDto } from '../api-client/types-old'
import { useOrders } from '../hooks'
import { OrderLink } from './OrderLink'

export function OrderBooking({
  orderId,
  type,
  showOrderType = false,
  showSimpleId = false,
}: {
  orderId: string
  type?: OrderType
  showOrderType?: boolean
  showSimpleId?: boolean
}) {
  const { data, isSuccess } = useOrders({
    filters: { id: orderId, type },
  })

  const order: OrderAdminResponseDto | undefined = data?.items[0]

  if (isSuccess && order) {
    const badge = (
      <Badge colorScheme="green">
        {showOrderType ? type : null} {order.orderDetails.deliveryDate}
      </Badge>
    )
    return !showSimpleId ? (
      badge
    ) : (
      <HStack>
        <OrderLink orderId={orderId} />
        {badge}
      </HStack>
    )
  }
  return null
}
